















































































import Vue from "vue";
import ConfiguracionesGeneralesService from "@/api/ConfiguracionesGeneralesService";

export default Vue.extend({
  mounted() {
    this.getAll();    
  },
  data() {
    return {
      socialLinksCategories: [
        "FACEBOOK", "INSTAGRAM", "STRAVA"
      ] as string[],
      social: [
        {
          icon:  "mdi-instagram",
          data: "@keeprunningec",
          link: "https://www.instagram.com/keeprunningec"
        },
        {
          icon: "mdi-facebook",
          data: "@keeprunningec",
          link: "https://www.facebook.com/keeprunningec/?"
        },
        {
          icon: "$stravaIcon",
          data: "@keeprunningec",
          link: "https://www.strava.com/clubs/keeprunningec"
        }
      ],
      contacto: [
        {
          icon: " mdi-whatsapp",
          data: "+593 961664116",
          link:
            "https://wa.me/593961664116?text=Hola%20Keep%20Running%20necesito%20ayuda"
        },
        {
          icon: "mdi-phone",
          data: "096-166-4116",
          link: "tel:+593961664116"
        },
        {
          icon: "mdi-email",
          data: "contactenos@keeprunning.ec",
          link: "mailto:contactenos@keeprunning.ec"
        }
      ],
      atencion: [
        {
          icon: "mdi-calendar",
          data: "Lunes a Viernes"
        },
        {
          icon: "mdi-clock",
          data: "09:00 a 17:00"
        }
      ],
      datos: [] as any[]
    };
  },
  methods: {
    getAll() {
      ConfiguracionesGeneralesService.getAll()
        .then(response => {
          this.datos = response; 
          console.log("Datos fetched:", this.datos);
          this.buildSocialLinks();
          this.buildContactoLinks();
        })
        .catch(error => {
          console.error("Error fetching data:", error);
        });
    },
    buildSocialLinks() {
      const socialLinks = [];

      for (const dato of this.datos) {
        if (dato.categoria == "FACEBOOK") {
          socialLinks.push({
            icon: "mdi-facebook",
            data: dato.descripcion ?? "@keeprunningec",
            link: dato.valor ?? "https://www.facebook.com/keeprunningec/?"
          });
        } else if (dato.categoria == "INSTAGRAM") {
          socialLinks.push({
            icon: "mdi-instagram",
            data: dato.descripcion ?? "@keeprunningec",
            link: dato.valor ?? "https://www.instagram.com/keeprunningec"
          });
        } else if (dato.categoria == "STRAVA") {
          socialLinks.push({
            icon: "$stravaIcon",
            data: dato.descripcion ?? "@keeprunningec",
            link: dato.valor ?? "https://www.strava.com/clubs/keeprunningec"
          });
        }
      }
      
      if (socialLinks.length == 3) {
        this.social = socialLinks;
      }
    },
    buildContactoLinks() {
      const contactoLinks = [];

      for (const dato of this.datos) {
        if (dato.categoria == "WHATSAPP") {
          contactoLinks.push({
            icon: "mdi-whatsapp",
            data: dato.descripcion ?? "+593 961664116",
            link: dato.valor ?? "https://wa.me/593961664116?text=Hola%20Keep%20Running%20necesito%20ayuda"
          });
        } else if (dato.categoria == "TELEFONO") {
          contactoLinks.push({
            icon: "mdi-phone",
            data: dato.descripcion ?? "096-166-4116",
            link: 'tel:+593' + (dato.link ?? "961664116")
          });
        } else if (dato.categoria == "EMAIL") {
          contactoLinks.push({
            icon: "mdi-email",
            data: dato.descripcion ?? "contactenos@keeprunning.ec",
            link: 'mailto:'+  (dato.valor ?? 'contactenos@keeprunning.ec')
          });
        }
      }

      if (contactoLinks.length == 3) {
        this.contacto = contactoLinks;
      }
    },
  },
});
